module.exports = __webpack_public_path__ + "img/bl.72ef2ba8.svg";